"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipWrapper = exports.TooltipTarget = exports.TooltipBox = exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getColorsStylesByVariant = function getColorsStylesByVariant(_ref) {
  var variant = _ref.variant,
    color = _ref.color,
    shadow = _ref.shadow;
  return {
    primary: {
      background: color.brandSecondary.light,
      boxShadow: shadow.level['04'],
      color: color.neutral['08']
    },
    secondary: {
      background: color.brandPrimary.light,
      boxShadow: shadow.level['04'],
      color: color.neutral['08']
    },
    gray: {
      backgroundColor: color.neutral['06'],
      color: color.brandPrimary.light
    }
  }[variant];
};
var getBorderColor = function getBorderColor(_ref2) {
  var variant = _ref2.variant,
    color = _ref2.color;
  return {
    primary: color.brandSecondary.light,
    secondary: color.brandPrimary.light,
    outlined: color.brandPrimary.light,
    gray: color.neutral['06']
  }[variant];
};
var getArrowStyleByPosition = function getArrowStyleByPosition(_ref3) {
  var position = _ref3.position,
    variant = _ref3.variant,
    color = _ref3.color;
  switch (position) {
    case 'bottom':
      return {
        borderColor: "transparent transparent ".concat(getBorderColor({
          variant: variant,
          color: color
        }), " transparent"),
        top: 'unset',
        width: '1px',
        bottom: '100%',
        left: 'calc(50% - 5px)'
      };
    case 'left':
      return {
        borderColor: "transparent transparent  transparent ".concat(getBorderColor({
          variant: variant,
          color: color
        })),
        left: '100%',
        top: 'calc(50% - 5px)',
        width: '1px'
      };
    case 'right':
      return {
        borderColor: " transparent ".concat(getBorderColor({
          variant: variant,
          color: color
        }), " transparent  transparent"),
        right: '100%',
        left: 'unset',
        top: 'calc(50% - 5px)'
      };
    default:
      return {};
  }
};
var TooltipWrapper = exports.TooltipWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Tooltipstyle__TooltipWrapper",
  componentId: "sc-tm1omm-0"
})({
  position: 'relative',
  display: 'inline-flex'
});
var TooltipTarget = exports.TooltipTarget = _styledComponents["default"].button.withConfig({
  displayName: "Tooltipstyle__TooltipTarget",
  componentId: "sc-tm1omm-1"
})(function (_ref4) {
  var showOnFocus = _ref4.showOnFocus;
  return _objectSpread({
    border: 'none',
    background: 'inherit',
    padding: '5px',
    margin: '-1px',
    fontSize: 'inherit',
    color: 'inherit',
    cursor: 'inherit',
    display: 'flex'
  }, !showOnFocus && {
    outline: 'none'
  });
});
var getContainerStyleByPosition = function getContainerStyleByPosition(position) {
  switch (position) {
    case 'bottom':
      return {
        bottom: 'unset !important',
        top: 'calc(100% + 5px)'
      };
    case 'left':
      return {
        marginRight: 0,
        left: 'unset',
        top: '50%',
        right: 'calc(100% + 5px)',
        width: 'max-content'
      };
    case 'right':
      return {
        marginLeft: 0,
        top: '50%',
        left: 'calc(100% + 5px)',
        width: 'max-content'
      };
    default:
      return {
        bottom: 'calc(100% + 5px)'
      };
  }
};
var Container = exports.Container = _styledComponents["default"].div.withConfig({
  displayName: "Tooltipstyle__Container",
  componentId: "sc-tm1omm-2"
})(function (_ref5) {
  var position = _ref5.position;
  return _objectSpread({
    position: 'absolute',
    width: '200px',
    marginLeft: '-100px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    left: '50%',
    bottom: 'calc(100% + 5px)',
    pointerEvents: 'none'
  }, getContainerStyleByPosition(position));
});
var TooltipBox = exports.TooltipBox = _styledComponents["default"].span.withConfig({
  displayName: "Tooltipstyle__TooltipBox",
  componentId: "sc-tm1omm-3"
})(function (_ref6) {
  var _ref6$theme = _ref6.theme,
    color = _ref6$theme.color,
    shadow = _ref6$theme.shadow,
    border = _ref6$theme.border,
    variant = _ref6.variant,
    position = _ref6.position;
  return _objectSpread(_objectSpread({
    position: 'relative',
    textAlign: 'center',
    borderRadius: border.radius.xs,
    padding: '10px 8px',
    fontSize: 14
  }, getColorsStylesByVariant({
    variant: variant,
    color: color,
    shadow: shadow
  })), {}, {
    '&:after': _objectSpread({
      content: '""',
      position: 'absolute',
      width: '1px',
      height: '1px',
      borderWidth: '5px',
      borderStyle: 'solid',
      borderColor: "".concat(getBorderColor({
        variant: variant,
        color: color
      }), " transparent transparent transparent"),
      left: 'calc(50% - 5px)',
      top: '100%'
    }, getArrowStyleByPosition({
      position: position,
      variant: variant,
      color: color
    }))
  });
});